import React from 'react';
import {ButtonBase} from '../elements';
import {useTranslation} from "react-i18next";
import clsx from "clsx";

interface KeyboardProps {
    addChar: (char: string) => void;
}

export function Keyboard(props: KeyboardProps) {
    const {i18n} = useTranslation();
    const handleClick = (char: string) => () => props.addChar(char);
    const keys = {
        en: [
            ['1', '2', '3', '4', '5', '6', '7', '8', '9', '0'],
            ['q', 'w', 'e', 'r', 't', 'y', 'u', 'i', 'o', 'p'],
            ['a', 's', 'd', 'f', 'g', 'h', 'j', 'k', 'l'],
            ['z', 'x', 'c', 'v', 'b', 'n', 'm']
        ],
        ru: [
            ['1', '2', '3', '4', '5', '6', '7', '8', '9', '0'],
            ['й', 'ц', 'у', 'к', 'е', 'н', 'г', 'ш', 'щ', 'з', 'х', 'ъ'],
            ['ф', 'ы', 'в', 'а', 'п', 'р', 'о', 'л', 'д', 'ж', 'э'],
            ['я', 'ч', 'с', 'м', 'и', 'т', 'ь', 'б', 'ю']
        ]
    };
    return (
        <React.Fragment>
            {keys[i18n.language as 'ru' | 'en'].map((chars, i, arr) => (
                <div
                key={i}
                className={clsx(
                  i < arr.length - 1 ? "hidden tablet:flex w-[81.5%] desktop:w-[54.38%] mx-auto gap-[16px]" : "hidden tablet:flex w-[66.56%] desktop:w-[44.38%] mx-auto gap-[14px]"
                )}
              >
                    {chars.map(char => (
                        <ButtonBase
                            key={char}
                            className={clsx(
                                "my-[8px] w-full rounded-[10px] text-[28px] font-['Roboto'] leading-[100%] font-normal",
                                i === 0 ? "bg-[#3C3E40] py-[11px]" : "bg-[#464646] py-[16px]"
                            )}
                            onClick={handleClick(char)}
                        >
                            {char.toUpperCase()}
                        </ButtonBase>
                    ))}
                </div>
            ))}
            <div className="flex justify-center">
                <ButtonBase
                    onClick={() => props.addChar(' ')}
                    className="mx-auto w-[51.25%] desktop:w-[34.17%] bg-[#464646] mt-[8px] rounded-[10px] py-[18px] shadow-[0_3px_0_0_#3C3C3D]"
                >
                    &nbsp;
                </ButtonBase>
            </div>
        </React.Fragment>
    );
}
